export const FETCH_DESIGNATIONS_REQUEST = "FETCH_DESIGNATIONS_REQUEST"
export const FETCH_DESIGNATIONS_SUCCESS = "FETCH_DESIGNATIONS_SUCCESS"
export const FETCH_DESIGNATIONS_FAILURE = "FETCH_DESIGNATIONS_FAILURE"

export const FETCH_CATEGORIES_REQUEST = "FETCH_CATEGORIES_REQUEST"
export const FETCH_CATEGORIES_SUCCESS = "FETCH_CATEGORIES_SUCCESS"
export const FETCH_CATEGORIES_FAILURE = "FETCH_CATEGORIES_FAILURE"

export const FETCH_COMPANIES_REQUEST = "FETCH_COMPANIES_REQUEST"
export const FETCH_COMPANIES_SUCCESS = "FETCH_COMPANIES_SUCCESS"
export const FETCH_COMPANIES_FAILURE = "FETCH_COMPANIES_FAILURE"

export const FETCH_INDUSTRIES_REQUEST = "FETCH_INDUSTRIES_REQUEST"
export const FETCH_INDUSTRIES_SUCCESS = "FETCH_INDUSTRIES_SUCCESS"
export const FETCH_INDUSTRIES_FAILURE = "FETCH_INDUSTRIES_FAILURE"

export const FETCH_SITE_OPTIONS_REQUEST = "FETCH_SITE_OPTIONS_REQUEST"
export const FETCH_SITE_OPTIONS_SUCCESS = "FETCH_SITE_OPTIONS_SUCCESS"
export const FETCH_SITE_OPTIONS_FAILURE = "FETCH_SITE_OPTIONS_FAILURE"

export const SEARCH_USER_QUERY_REQUEST = "SEARCH_USER_QUERY_REQUEST"
export const SEARCH_USER_QUERY_SUCCESS = "SEARCH_USER_QUERY_SUCCESS"
export const SEARCH_USER_QUERY_FAILURE = "SEARCH_USER_QUERY_FAILURE"
